import TasksCarousel from "./tasks-carousel";
import ProgressBar from "./progress-bar";

export default { TasksCarousel, ProgressBar };
